import type { Ref } from "react";
import PropTypes from "prop-types";
import "../../styles/inputGroups.css";

export { InputGroup };

type Props = {
  children: PropTypes.ReactNodeArray | PropTypes.ReactNodeLike;
  button?: boolean;
  /**
   * Lower priority HTML classes
   */
  className?: string;
};

const InputGroup = ({
  ref,
  ...props
}: Props & {
  ref?: Ref<HTMLSpanElement>;
}) => {
  const className = props.button ? "inputGroupButton" : "inputGroup";
  return (
    <span className={`${className} ${props.className}`} ref={ref}>
      {props.children}
    </span>
  );
};
